import { combineReducers } from 'redux';
import { material } from './material';
import { user } from './user';
import { api } from './api';
import { materialOrderLineItemModel } from './materialOrderLineItem';
import { materialRequest } from './material-request';
import { materialSelection } from './material-selection';
import { stockPreview } from './stockPreview';
import { salesOrder } from './salesorder';
import { salesOrderLineItem } from './salesOrderLineItem';
import { manufacturing } from './manufacturing';
import { quality } from './quality';
import { ballooning } from './ballooning';

const reducers = combineReducers({
	user: user.reducer,
	material: material.reducer,
	materialRequest: materialRequest.reducer,
	materialSelection: materialSelection.reducer,
	stockPreview: stockPreview.reducer,
	materialOrderLineItemModel: materialOrderLineItemModel.reducer,
	salesorder: salesOrder.reducer,
	salesOrderLineItem: salesOrderLineItem.reducer,
	manufacturing: manufacturing.reducer,
	ballooning: ballooning.reducer,
	quality: quality.reducer,
	[api.reducerPath]: api.reducer,
});

export default reducers;
